'use strict';

var debug;
var assert;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:invoke');
    assert = require('assert');
}

var env = require('./env.js');
var ready = require('./ready.js');
var buildURI = require('./build-uri.js');
var sendURI = require('./send-uri.js');

var invoke = function(moduleName, methodName, parameters, protocol) {
    if (process.env.NODE_ENV !== 'production') {
        //assert(env.HBNBReady);
        debug('module = %s', moduleName);
        debug('method = %s', methodName);
        debug('parameters = %j', parameters);
        debug('protocol = %s', protocol);
    }

    // return if not in meituan app
    if (process.env.NODE_ENV === 'production') {
        if (!env.isHBNBWebview) {
            if (parameters && parameters.complete) {
                var complete = parameters.complete;
                if (typeof complete === 'function') {
                    setTimeout(function() {
                        complete({
                            status: 200,
                            message: 'not HBNB webview'
                        });
                    });
                }
                return;
            }
        }
    }

    // throw Error on development
    if (process.env.NODE_ENV !== 'production') {
        assert(typeof moduleName === 'string' && moduleName);
        assert(typeof methodName === 'string' && methodName);
    }

    parameters = parameters || {};
    protocol = protocol || 'magpie:';
    var uri = buildURI(protocol, moduleName, methodName, parameters);

    if (process.env.NODE_ENV !== 'production') {
        debug('uri = %s', uri);
    }

    ready(function() {
        sendURI(uri);
    });
};

module.exports = invoke;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/hbnb/invoke/invoke.js
// module id = l9VO
// module chunks = 0